import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { BreadCrumb, Loader } from './../../../../Common';
import { Container } from 'reactstrap';
import Table from './Components/Tables/Table';
import { GET_CATEGORY, GET_LOCATION, GET_PARTNER, GET_SERVICE, UPDATE_SERVICE_EMPTY } from '../../../../../store/application/actionType';
import { Constant } from '../../../../Helpers/constant';
import Details from './Components/Details/Details';
import ServiceForm from './../AddService/Components/Form';
import Filter from './Components/Filters/Filter';
import CustomFilter from './Components/Filters/CustomFilter';
import DetailsInfo from './Components/Details/DetailsInfo';
import LogsModal from './Components/Modals/LogsModal';
import moment from 'moment';

const ManageService = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [loading, setLoading] = useState(false);
  const [isShowFilters, setIsShowFilters] = useState(false);

  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);

  const [currentSelectedDetails, setCurrentSelectedDetails] = useState([]);
  const [currentConfirmationModalActionFor, setCurrentConfirmationModalActionFor] = useState(null);

  const [isListShow, setIsListShow] = useState(true);
  const [isDetailsPageShow, setIsDetailsPageShow] = useState(false);
  const [isUpdateFormShow, setIsUpdateFormShow] = useState(false);

  const [isShowLogsModal, setIsShowLogsModal] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  // Get Services
  const { services, servicesLoading } = useSelector(state => ({
    services: state?.GetService?.data,
    servicesLoading: state?.GetService?.loading,
  }));

  // Update Service
  const { updateService, updateServiceLoading } = useSelector(state => ({
    updateService: state?.UpdateService?.data,
    updateServiceLoading: state?.UpdateService?.loading,
  }));

  /* ---------------------------- DISPATCHING ---------------------------- */
  useEffect(() => {
    dispatch({
      type: GET_SERVICE,
      payload: {
        urlParam: {
          pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
        },
      },
    });

    dispatch({
      type: GET_PARTNER,
      payload: {
        urlParam: {
          pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
        },
      },
    });

    dispatch({
      type: GET_CATEGORY,
      payload: {
        urlParam: {
          pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
        },
      },
    });

    dispatch({
      type: GET_LOCATION,
      payload: {
        urlParam: {
          pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
        },
      },
    });
  }, [dispatch]);

  useEffect(() => {
    if (updateService !== null) {
      dispatch({
        type: UPDATE_SERVICE_EMPTY,
      });

      setIsListShow(true);
      setIsDetailsPageShow(false);
      setIsUpdateFormShow(false);

      let urlParams = {};
      if (currentlyAppliedFilters) {
        urlParams = {
          name: currentlyAppliedFilters?.name === `` ? null : currentlyAppliedFilters?.name,
          typeId: currentlyAppliedFilters?.typeId === `` ? null : currentlyAppliedFilters?.typeId,
          updateDate: currentlyAppliedFilters?.updateDate === `` ? null : moment(new Date(currentlyAppliedFilters?.updateDate)).format('YYYY-MM-DD'),
          categoryId: currentlyAppliedFilters?.categoryId === null ? null : currentlyAppliedFilters?.categoryId?.value,
          partnerId: currentlyAppliedFilters?.partnerId === null ? null : currentlyAppliedFilters?.partnerId?.value,
          facilityId: currentlyAppliedFilters?.facilityId === null ? null : currentlyAppliedFilters?.facilityId?.value,
          countryId: currentlyAppliedFilters?.countryId === null ? null : currentlyAppliedFilters?.countryId?.value,
        };
      }

      dispatch({
        type: GET_SERVICE,
        payload: {
          urlParam: {
            pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
            ...urlParams,
          },
        },
      });
    }
  }, [updateService]);

  /* ---------------------------- FILTER SUBMIT HANDLER ---------------------------- */
  const filterSubmitHandler = filters => {
    setIsShowFilters(false);
    setCurrentlyAppliedFilters(filters);
    setCurrentPageNumber(0);

    const urlParams = {
      name: filters?.name === `` ? null : filters?.name,
      typeId: filters?.typeId === `` ? null : filters?.typeId,
      updateDate: filters?.updateDate === `` ? null : moment(new Date(filters?.updateDate)).format('YYYY-MM-DD'),
      categoryId: filters?.categoryId === null ? null : filters?.categoryId?.value,
      partnerId: filters?.partnerId === null ? null : filters?.partnerId?.value,
      facilityId: filters?.facilityId === null ? null : filters?.facilityId?.value,
      countryId: filters?.countryId === null ? null : filters?.countryId?.value,
    };

    dispatch({
      type: GET_SERVICE,
      payload: {
        urlParam: {
          pageIndex: 0,
          ...urlParams,
        },
      },
    });
  };

  /* ---------------------------- PAGINATION HANDLER ---------------------------- */
  const paginationHandler = pageNumber => {
    setCurrentPageNumber(pageNumber);

    let urlParams = {};
    if (currentlyAppliedFilters) {
      urlParams = {
        name: currentlyAppliedFilters?.name === `` ? null : currentlyAppliedFilters?.name,
        typeId: currentlyAppliedFilters?.typeId === `` ? null : currentlyAppliedFilters?.typeId,
        updateDate: currentlyAppliedFilters?.updateDate === `` ? null : moment(new Date(currentlyAppliedFilters?.updateDate)).format('YYYY-MM-DD'),
        categoryId: currentlyAppliedFilters?.categoryId === null ? null : currentlyAppliedFilters?.categoryId?.value,
        partnerId: currentlyAppliedFilters?.partnerId === null ? null : currentlyAppliedFilters?.partnerId?.value,
        facilityId: currentlyAppliedFilters?.facilityId === null ? null : currentlyAppliedFilters?.facilityId?.value,
        countryId: currentlyAppliedFilters?.countryId === null ? null : currentlyAppliedFilters?.countryId?.value,
      };
    }

    dispatch({
      type: GET_SERVICE,
      payload: {
        urlParam: {
          pageIndex: pageNumber * Constant.TABLE_PAGE_SIZE,
          ...urlParams,
        },
      },
    });
  };

  /* ---------------------------- TABLE ACTION HANDLER ---------------------------- */
  const tableActionHandler = params => {
    setCurrentSelectedDetails(params?.details);
    setCurrentConfirmationModalActionFor(params?.actionType);

    if (params?.actionType === `INFO`) {
      setIsListShow(false);
      setIsDetailsPageShow(true);
      setIsUpdateFormShow(false);
    } else if (params?.actionType === `UPDATE`) {
      setIsListShow(false);
      setIsDetailsPageShow(false);
      setIsUpdateFormShow(true);
    } else if (params?.actionType === `LOGS`) {
      setIsShowLogsModal(true);
    }
  };

  /* ---------------------------- BREADCRUM HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push('/dashboard');
    } else if (title === `Benefit`) {
      setIsListShow(true);
      setIsDetailsPageShow(false);
      setIsUpdateFormShow(false);

      let urlParams = {};
      if (currentlyAppliedFilters) {
        urlParams = {
          name: currentlyAppliedFilters?.name === `` ? null : currentlyAppliedFilters?.name,
          typeId: currentlyAppliedFilters?.typeId === `` ? null : currentlyAppliedFilters?.typeId,
          updateDate: currentlyAppliedFilters?.updateDate === `` ? null : moment(new Date(currentlyAppliedFilters?.updateDate)).format('YYYY-MM-DD'),
          categoryId: currentlyAppliedFilters?.categoryId === null ? null : currentlyAppliedFilters?.categoryId?.value,
          partnerId: currentlyAppliedFilters?.partnerId === null ? null : currentlyAppliedFilters?.partnerId?.value,
          facilityId: currentlyAppliedFilters?.facilityId === null ? null : currentlyAppliedFilters?.facilityId?.value,
          countryId: currentlyAppliedFilters?.countryId === null ? null : currentlyAppliedFilters?.countryId?.value,
        };
      }

      dispatch({
        type: GET_SERVICE,
        payload: {
          urlParam: {
            pageIndex: currentPageNumber * Constant.TABLE_PAGE_SIZE,
            ...urlParams,
          },
        },
      });
    } else if (title === `Details`) {
      // do nothing
    } else if (title === `Update Details`) {
      // do nothing
    }
  };

  /* ---------------------------- LOADING HANDLER ---------------------------- */
  useEffect(() => {
    if (servicesLoading || updateServiceLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [servicesLoading, updateServiceLoading]);

  return (
    <>
      {loading && <Loader />}

      <div className="page-content">
        <Container fluid className="position-relative">
          {/*  ----------------------------  MODAL'S ---------------------------- */}
          {isShowLogsModal && <LogsModal data={currentSelectedDetails} onCloseHandler={() => setIsShowLogsModal(false)} />}

          {/*  ----------------------------  UI'S ---------------------------- */}
          {isListShow && (
            <>
              <BreadCrumb title="Benefit" navigationby={breadcrumNavigationHandler} navigation={['Dashboard', 'Benefit']} />

              {/* <Filter
                filterHandler={filterSubmitHandler}
                appliedFilters={currentlyAppliedFilters}
              /> */}

              <CustomFilter
                filterHandler={filterSubmitHandler}
                appliedFilters={currentlyAppliedFilters}
                show={isShowFilters}
                onCloseClick={() => setIsShowFilters(false)}
              />

              <Table
                title={`Benefit's Data`}
                data={services?.results}
                totalData={services?.count}
                pageHandler={paginationHandler}
                pageNumber={currentPageNumber}
                actionHandler={tableActionHandler}
                isShowFilterBtn={true}
                filterBtnHandler={() => setIsShowFilters(true)}
              />
            </>
          )}

          {isDetailsPageShow && (
            <>
              <BreadCrumb title="Benefit" navigationby={breadcrumNavigationHandler} navigation={['Dashboard', 'Benefit', 'Benefit Details']} />

              <DetailsInfo details={currentSelectedDetails} editActionHandler={tableActionHandler} />
              {/* <Details details={currentSelectedDetails} /> */}
            </>
          )}

          {isUpdateFormShow && (
            <>
              <BreadCrumb title="Category" navigationby={breadcrumNavigationHandler} navigation={['Dashboard', 'Benefit', 'Update Details']} />

              <ServiceForm data={currentSelectedDetails} title="Update Benefit" />
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default ManageService;
